import React from 'react'
import { PromoCodesList } from './list/page'

export const PromoCodesPage: React.FC = () => {
  return <PromoCodesList />
}
